import { useContext, useEffect, useState } from "react";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { contestationPeriodsService } from "../../services/ContestationPeriodsService";
import ScreenLoader from "../../componets/ScreenLoader";
import { Dropdown } from "primereact/dropdown";

export default function () {
    var { selectedParty, setSelectedParty, contestationPeriodID, setContestationPeriodID } = useContext(PoliticalPartyDBContext);
    var [contestationPeriod, setContestationPeriod] = useState([]);
    var [loading, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true)
        contestationPeriodsService.getContestationPeriods().then(res => {
            setContestationPeriod(res.map(e => {
                e.contestationPeriodID= e.membershipPeriodID
                return e
            }))

            res.forEach(res => {
                if (res.isCurrent) {
                    if (["", null, undefined].includes(contestationPeriodID)) {
                        setContestationPeriodID(res.contestationPeriodID)
                        return;
                    }

                }
            })
            setLoading(false)
        })
    }, [])
    return (<>
        <ScreenLoader visible={loading} />
        <div>
            <b>Membership Year</b>
            <br />
            <Dropdown value={contestationPeriodID} onChange={e => setContestationPeriodID(e.value)} className="w-full" options={contestationPeriod} optionLabel="registrationYear" optionValue="contestationPeriodID" />
        </div>
    </>)
}